const TemperatureType = ({ setFilterFn }) => {
  const handleClick = (choice) => {
    setFilterFn({
      choice: choice,
      filterClassification: "food",
      filterType: "temperature",
      nextFilter: "panType",
    })
  }

  return (
    <div>
      <h2 className="selection-title">I will be transporting...</h2>
      <div className="col-sm-4" onClick={ () => handleClick("hot") }>
        <div className="selection-box">
          <img src="/assets/bat_hot.jpg" className="bat-image" />
          <br />
          <span>Hot Only</span>
        </div>
      </div>

      <div className="col-sm-4" onClick={ () => handleClick("hot_and_cold") }>
        <div className="selection-box">
          <img src="/assets/bat_hot-cold.jpg" className="bat-image" />
          <br />
          <div>Hot & Cold</div>
        </div>
      </div>

      <div className="col-sm-4" onClick={ () => handleClick("cold") }>
        <div className="selection-box">
          <img src="/assets/bat_cold.jpg" className="bat-image" />
          <br />
          <span>Cold</span>
        </div>
      </div>
    </div>
  )
}

export default TemperatureType
